// Literal import.meta.env.VITE_* reads so Vite can inline them at build time (mirrors apps/mobile/src/lib/env.ts).
const apiUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

export const env = {
  /** apps/api base URL. Empty → same origin, i.e. the Vite dev proxy (/v1, /dev, /health → localhost:4000). */
  apiUrl,
  /**
   * Auth0, one tenant shared with parents and separated by role. All three must be present or the
   * portal falls back to the dev-token stub — which only works against a local API, because
   * `POST /dev/token` is not registered when NODE_ENV is production.
   */
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
  /** Must equal the audience apps/api validates, or a perfectly good token verifies against nothing. */
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? '',
  /*
   * **`appUrl` WAS HERE AND IS GONE** (Evan, 2026-09-22). It held the universal-link host, and "Open the app"
   * sent a parent to it. On a phone with the app installed that is intercepted; everywhere else the host is
   * the API, which answers `GET /` with raw JSON — so on every desktop the console's only outbound link was a
   * dead end. A parent is sent to a STORE now (`components/GetTheApp`), and `noAppSchemeLinks` fails the build
   * if this value, or any app scheme, comes back.
   */
} as const;

/** HttpClient rejects an empty baseUrl, so the proxied origin is passed explicitly. */
export function apiBaseUrl(): string {
  return env.apiUrl || window.location.origin;
}

/** Auth0 is used when it is fully configured; anything less is the dev stub, never a half-setup. */
export function auth0Config(): { domain: string; clientId: string; audience: string } | null {
  const { auth0Domain: domain, auth0ClientId: clientId, auth0Audience: audience } = env;
  return domain && clientId && audience ? { domain, clientId, audience } : null;
}
